import React from 'react';
import styled from 'styled-components';

import type { QrShareStatus } from '../../../types/api';

const STATUS_LABELS: Record<QrShareStatus, string> = {
  active: 'Activo',
  expired: 'Vencido',
  revoked: 'Revocado',
  archived: 'Archivado',
};

const STATUS_COLORS: Record<QrShareStatus, { bg: string; fg: string }> = {
  active: {
    bg: 'var(--success-50, #dcfce7)',
    fg: 'var(--success-600, #15803d)',
  },
  expired: {
    bg: 'var(--warning-50, #fef3c7)',
    fg: 'var(--warning-600, #b45309)',
  },
  revoked: {
    bg: 'var(--danger-50, #fee2e2)',
    fg: 'var(--danger-600, #b91c1c)',
  },
  archived: { bg: 'var(--neutral-100, #f3f4f6)', fg: 'var(--text-muted)' },
};

const Badge = styled.span<{ $bg: string; $fg: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px var(--space-sm);
  border-radius: 999px;
  background: ${(props) => props.$bg};
  color: ${(props) => props.$fg};
  font-size: var(--font-size-sm);
  font-weight: 600;
  white-space: nowrap;
`;

const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
`;

export interface QrShareStatusBadgeProps {
  status: QrShareStatus;
}

/** Status is carried by the label, not only by colour, per the a11y requirement. */
export const QrShareStatusBadge: React.FC<QrShareStatusBadgeProps> = ({
  status,
}) => {
  const colors = STATUS_COLORS[status];
  return (
    <Badge $bg={colors.bg} $fg={colors.fg}>
      <Dot aria-hidden="true" />
      {STATUS_LABELS[status]}
    </Badge>
  );
};

export { STATUS_LABELS as QR_SHARE_STATUS_LABELS };
